import React from 'react';
import { styled } from '@goodrx/matisse';
import { LegalAgreementModal } from 'app/components/LegalAgreementModal';
import { AppFooter } from 'app/components/footers/AppFooter';
import { withRouter } from 'react-router-dom';
import { AppHeader } from '../AppHeader';
import { RegistrationHeader } from '../RegistrationHeader';
import { MaintenanceBanner } from '../MaintenanceMode';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  min-height: 100vh;
`;

const Main = styled.main`
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  padding-bottom: 1rem;
`;

export const AppLayout = withRouter(({ location, children }) => {
  const isRegisterPath = location.pathname === '/register';

  return (
    <Wrapper id="wrapper">
      <MaintenanceBanner />
      {isRegisterPath && <RegistrationHeader />}
      {!isRegisterPath && <AppHeader />}
      <Main>{children}</Main>
      <LegalAgreementModal />
      {isRegisterPath ? null : <AppFooter />}
    </Wrapper>
  );
});
